import React from 'react';
import { ErrorBox } from './error-box';

export const GenericErrorBox: React.FC = (): React.ReactElement => {
    return <ErrorBox message="Something went wrong.  Please try again later" />;
};
